import React from 'react'
import styled from 'styled-components'

const LoginButton = ({ text, iconLeft, iconRight, leftIconStyle, rightIconStyle, ...props }) => {
    return (
        <ButtonContainer {...props}>
            {iconLeft && <IconWrapper style={leftIconStyle}>{iconLeft}</IconWrapper>}
            {text}
            {iconRight && <IconWrapper style={rightIconStyle}>{iconRight}</IconWrapper>}
        </ButtonContainer>
    )
}

export default LoginButton
const ButtonContainer = styled.button`
border-radius:10px;
display:flex;
align-items:center;
justify-content:center;
padding:12px 16px;
color:${({ theme }) => theme.loginButton.color};
background:${({ theme }) => theme.loginButton.background};
border:1px solid ${({ theme }) => theme.loginButton.borderColor};
gap:12px;
font-weight: 600;
font-size: 16px;
line-height: 100%;
letter-spacing: 0.04px;
cursor:pointer;

&:disabled{
opacity:0.4;
}
`

const IconWrapper = styled.span`
    display: flex;
    align-items: center;
height:24px;
width:24px;
`